import { Grid, Rating, Typography, useTheme } from '@mui/material'
import { MdCheck } from 'react-icons/md'
import { Stepper } from '..'
import { useBrand } from '../../utils/brand'
import { IperiaFormDefaultState } from '../../utils/constants'
import type { IperiaFormType } from '../../utils/sharedTypes'

type EdumiamDrawerProps = {
  steps?: IperiaFormType['steps']
}

const EdumiamDrawer = ({ steps = IperiaFormDefaultState.steps }: EdumiamDrawerProps) => {
  const theme = useTheme()
  const brand = useBrand()
  const { LogoComponent } = brand

  return (
    <Grid
      item
      sm={4}
      md={3}
      container
      direction="column"
      justifyContent="flex-start"
      alignItems="flex-start"
      wrap="nowrap"
      sx={{
        position: 'fixed',
        background: theme.palette.primary.light,
        p: 2,
        pl: 4,
        height: '100vh',
        display: { xs: 'none', sm: 'flex' },
        width: '300px',
      }}
    >
      <Grid item sx={{ cursor: 'pointer', alignSelf: 'flex-start', flexShrink: 0, lineHeight: 0 }}>
        <LogoComponent
          width={180}
          height={48}
          style={{ display: 'block', overflow: 'visible' }}
          onClick={() => {
            window.open(brand.websiteUrl, '_self')
          }}
        />
      </Grid>
      <Grid
        item
        sx={{
          flexGrow: 1,
          pt: 8,
          width: '100%',
          alignSelf: 'stretch',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'flex-start',
        }}
      >
        <Typography variant="body2" sx={{ mb: 2 }}>
          {brand.footerTagline}
        </Typography>
        <Stepper steps={steps} />
      </Grid>
      <Grid item container direction="column" sx={{ mb: 4, mt: 'auto', width: '100%' }}>
        <Grid item container alignItems="center" sx={{ mb: 2, mt: 2 }}>
          <Typography variant="body1" sx={{ mr: 1, fontWeight: 'bold' }}>
            {brand.googleRating} sur Google
          </Typography>
          <Rating value={brand.googleRating} precision={0.1} readOnly />
        </Grid>
        <Grid item>
          <Grid item container alignItems="center" sx={{ pb: 1 }} wrap="nowrap">
            <MdCheck size="12" style={{ color: theme.palette.success.main, marginRight: 4 }} />
            <Typography variant="body2">Formations 100% en ligne</Typography>
          </Grid>
          <Grid item container alignItems="center" sx={{ pb: 1 }} wrap="nowrap">
            <MdCheck size="12" style={{ color: theme.palette.success.main, marginRight: 4 }} />
            <Typography variant="body2">Par des spécialistes reconnus</Typography>
          </Grid>
          <Grid item container alignItems="center" wrap="nowrap">
            <MdCheck size="12" style={{ color: theme.palette.success.main, marginRight: 4 }} />
            <Typography variant="body2">Sur ordinateur, tablette ou mobile</Typography>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  )
}

export default EdumiamDrawer
